export default "__VITE_ASSET__BgOMJCxR__"